module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("API Settings")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm6": ""
    }
  }, [_c('b', [_vm._v("API Key")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.updateKey
    }
  }, [_vm._v("Update Key")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.disableapi
    }
  }, [_vm._v("Disable API")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "single-line": "",
      "outline": "",
      "readonly": "",
      "light": ""
    },
    model: {
      value: (_vm.apikey),
      callback: function($$v) {
        _vm.apikey = $$v
      },
      expression: "apikey"
    }
  }), _vm._v(" "), _c('b', [_vm._v("API IP")]), _vm._v(" "), _c('a', {
    ref: "changeipbutt",
    on: {
      "click": _vm.changeip
    }
  }, [_vm._v("Change IP")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.resetip
    }
  }, [_vm._v("Allow all")]), _vm._v(" "), _c('v-text-field', {
    ref: "ipbox",
    attrs: {
      "single-line": "",
      "outline": "",
      "readonly": _vm.editableip,
      "light": ""
    },
    model: {
      value: (_vm.apiip),
      callback: function($$v) {
        _vm.apiip = $$v
      },
      expression: "apiip"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f15e80c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/APISettings.vue
// module id = 401
// module chunks = 1